<template>
    <div class="login">
        <v-form  :dark='dark' v-model="valid" class="d-flex flex-column">
            <span class="font-weight-bold">Email</span>
            <v-text-field :dark='dark' required v-model="email" :rules="emailRules" placeholder="katty.martini@orpi.com"></v-text-field>
            <span class="font-weight-bold">Mot de passe</span>
            <v-text-field
                    :dark='dark'
                    required
                    v-model="password"
                    :rules="passwordRules"
                    placeholder="Mot de passe"
                    :type="showPwd ? 'text' : 'password'"
                    :append-icon="showPwd ? 'mdi-eye' : 'mdi-eye-off'"
                    @click:append="showPwd = !showPwd">
            </v-text-field>
            <router-link to="forgot-password" class="cursor-pointer text-right caption d-block text-decoration-none mb-16 secondary-hover">Mot de passe oublié ?</router-link>
            <v-btn x-large :dark='dark' :disabled="!valid" class="mt-5 mx-auto primary-button" @click="validate()" >Se connecter</v-btn>
        </v-form>
    </div>
</template>
<script>
import Vue from 'vue'
import { recaptchaKey } from '@/../config'
import { VueReCaptcha } from 'vue-recaptcha-v3'
// For more options see below
Vue.use(VueReCaptcha, { siteKey: recaptchaKey })


export default {
    name: 'loginform',
    props: {
        theme: { type: String },
        cta: {
            type: String,
            default: () => { return 'Valider' }
        }
    },
    data () {
        return {
            password: '',
            email: '',
            valid: false,
            showPwd: false,
            emailRules: [
                v => !!v || 'An email is mandatory',
                v => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'Please add a correct email address'
            ],
            pseudoRules: [
                v => !!v || 'Username is mandatory'
            ],
            passwordRules: [
                v => !!v || 'Password is mandatory'
            ]
        }
    },
    computed: {
        dark () {
            return this.theme === 'dark'
        }
    },
    methods: {
        async validate () {
            try {
                const recaptcha = await this.$recaptcha('register')
                await this.$store.dispatch('auth_request', { email: this.email, password: this.password, recaptcha })
                this.$emit('complete')
            } catch (e) {
                console.log(e)
                this.$store.dispatch('open_dialog', { message: e.message })
            }
        }
    }
}
</script>
<style lang="scss" >
.login{
    .theme--dark.v-input input, .theme--dark.v-input textarea{
        transition: all ease 500000000s;
    }
}
</style>